<template>
  <div class="before-after-item">
    <div class="before-after-item__before">
      <slot name="before"/>
    </div>
    <div class="before-after-item__icon">
      <svg width="100%" height="100%" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.2902 15.7587C35.6833 16.1467 35.6874 16.7798 35.2994 17.1729L28.9769 23.5781C28.589 23.9711 27.9558 23.9752 27.5628 23.5873C27.1697 23.1993 27.1656 22.5661 27.5536 22.1731L33.1735 16.4796L27.48 10.8596C27.087 10.4716 27.0829 9.83847 27.4708 9.44541C27.8588 9.05236 28.492 9.04824 28.885 9.43622L35.2902 15.7587ZM0.458619 15.6922L34.5812 15.4704L34.5942 17.4704L0.471617 17.6921L0.458619 15.6922Z" fill="#FB8C00"/>
      </svg>
    </div>
    <div class="before-after-item__after">
      <slot name="after"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BeforeAfterLogItem',
    props: {

    },
  }
</script>

<style lang="less" scoped>
.before-after-item {
  display: flex;

  &__before {
    margin-right: 1.5em;
    //flex-grow: 1;

  }

  &__icon {
    svg {
      display: block;
      width: 1.8em;
    }
  }

  &__after {
    margin-left: 1.5em;
    //flex-grow: 1;
  }
}
</style>
